<template>
  <div class="importStaffStepTwo">
    <div class="breadcrumb-area pos-relative">
      <h1>Thêm danh sách Nhóm công việc từ file thành công</h1>
    </div>
    <!-- End Breadcrumb Area -->

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="step-content">
          <div class="step-upfile">
            <section class="open-input">
              <div class="oi-alert">
                <span style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload-thanhcong.svg" alt=""
                /></span>
              </div>
            </section>
            <div class="alert alert-success fade show" role="alert">
              <p class="text-center font-size-16">
                Số lượng bản ghi tải lên thành công: <b>{{ dataImport.length }}</b>
              </p>
            </div>
          </div>
          <div class="step-upfooter m-t-0">
            <ul>
              <li>
                <router-link class="btn btn-primary" :to="`/group-calendar-afs-import`"
                  >Nhập file mới</router-link
                >
              </li>
              <li>
                <router-link class="btn btn-outline-secondary" :to="`/group-calendar-afs`"
                  >Danh sách nhóm công việc</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        dataImport: 'staff/getDataCacheTableRow',
      }),
    },
  }
</script>

<style scoped></style>
